import React from "react";
import { Instagram, Mail, Phone, Globe } from "lucide-react";
import { useTranslation } from "react-i18next";
import logo from "../../assets/restaurant/logo.png";

const languages = [
	{ code: "es", label: "ES" },
	{ code: "en", label: "EN" },
	{ code: "ca", label: "CA" },
];

export default function Footer2() {
	const { t, i18n } = useTranslation();

	const changeLanguage = (lng) => {
		i18n.changeLanguage(lng);
	};

	return (
		<footer
			className="bg-white text-gray-600"
			style={{ fontFamily: "'Poppins', sans-serif" }}
		>
			<div className="max-w-6xl mx-auto px-6 py-12 grid grid-cols-1 md:grid-cols-3 gap-10">
				{/* Logo + Claim */}
				<div>
					<a href="/salones">
						<img src={logo} alt="Applaby" className="h-10 mb-4" />
					</a>
					<p className="text-sm leading-relaxed" style={{ color: "#888" }}>
						{t("salon2.footer.claim")}
					</p>
				</div>

				{/* Navigation */}
				<div className="flex flex-col gap-2.5 text-sm">
					<a
						href="/salones"
						className="hover:text-[#43BD98] transition-colors duration-200"
						style={{ color: "#555" }}
					>
						{t("salon2.footer.links.home")}
					</a>
					<a
						href="/salones#ejemplos"
						className="hover:text-[#43BD98] transition-colors duration-200"
						style={{ color: "#555" }}
					>
						{t("salon2.footer.links.examples")}
					</a>
					<a
						href="/salones#precios"
						className="hover:text-[#43BD98] transition-colors duration-200"
						style={{ color: "#555" }}
					>
						{t("salon2.footer.links.pricing")}
					</a>
					<a
						href="https://applaby.com/terminos"
						target="_blank"
						rel="noreferrer"
						className="hover:text-[#43BD98] transition-colors duration-200"
						style={{ color: "#555" }}
					>
						{t("salon2.footer.links.terms")}
					</a>
					<a
						href="https://applaby.com/politica-privacidad"
						target="_blank"
						rel="noreferrer"
						className="hover:text-[#43BD98] transition-colors duration-200"
						style={{ color: "#555" }}
					>
						{t("salon2.footer.links.privacy")}
					</a>
				</div>

				{/* Contact */}
				<div className="flex flex-col gap-3 text-sm">
					<a
						href="mailto:info@applaby.com"
						className="flex items-center gap-2 hover:text-[#43BD98] transition-colors duration-200"
						style={{ color: "#555" }}
					>
						<Mail className="w-4 h-4" /> info@applaby.com
					</a>
					<a
						href="tel:+34608916357"
						className="flex items-center gap-2 hover:text-[#43BD98] transition-colors duration-200"
						style={{ color: "#555" }}
					>
						<Phone className="w-4 h-4" /> +34 608 916 357
					</a>
					<a
						href="https://www.instagram.com/applaby_es"
						target="_blank"
						rel="noreferrer"
						className="flex items-center gap-2 hover:text-[#43BD98] transition-colors duration-200"
						style={{ color: "#555" }}
					>
						<Instagram className="w-5 h-5" /> @applaby_es
					</a>
				</div>
			</div>

			<div className="border-t border-gray-100 py-6">
				<div className="max-w-6xl mx-auto px-6 flex flex-col sm:flex-row items-center justify-between gap-4">
					<p className="text-xs text-center" style={{ color: "#aaa" }}>
						© {new Date().getFullYear()} Applaby. {t("salon2.footer.rights")}
					</p>
					<div className="flex items-center gap-2">
						<Globe className="w-4 h-4 text-gray-400" />
						<div className="flex gap-1">
							{languages.map((lang) => {
								const active = i18n.language?.startsWith(lang.code);
								return (
									<button
										key={lang.code}
										type="button"
										onClick={() => changeLanguage(lang.code)}
										className={`px-4 py-2 text-sm rounded transition ${
											active
												? "bg-[#43BD98] text-white"
												: "bg-gray-100 text-gray-600 hover:bg-gray-200"
										}`}
									>
										{lang.label}
									</button>
								);
							})}
						</div>
					</div>
				</div>
			</div>
		</footer>
	);
}
